import React from 'react';
import { useNavigate } from 'react-router-dom';
import FacturaForm from '../../components/FacturaForm';
import VentaRapidaForm from '../../components/VentaRapidaForm';
import PlanUsageBanner from '../../components/PlanUsageBanner';
import { FormShell } from '../../components/form';

/**
 * Pestaña «Cargar venta»: toggle rápida/completa + formularios.
 */
export default function FacturasCreatePanel({
  box,
  divide,
  textPri,
  textMuted,
  tabInactive,
  editId,
  editData,
  createMode,
  setCreateMode,
  setError,
  quickFormResetKey,
  onAdd,
  onSaveEdit,
  onCancelEdit,
  modoOscuro,
  facturas,
  preferImpagaOnboarding,
}) {
  const navigate = useNavigate();
  const isQuickNew = createMode === 'quick' && editId === null && !editData;

  const title = editId !== null
    ? 'Editar registro de venta'
    : isQuickNew
      ? 'Venta rápida'
      : 'Nuevo registro de venta';

  const subtitle = editId !== null
    ? 'Modificá los datos del comprobante.'
    : isQuickNew
      ? 'Monto y concepto primero; el resto es opcional.'
      : 'Completá comprobante, cliente y conceptos.';

  const switchMode = (modeId) => {
    setCreateMode(modeId);
    setError('');
    navigate(`/facturas?tab=crear&modo=${modeId === 'complete' ? 'completo' : 'rapido'}`, { replace: true });
  };

  const modeToggleInner = editId === null && !editData ? (
    <div className="grid grid-cols-2 gap-1">
      {[
        { id: 'complete', label: 'Venta completa' },
        { id: 'quick', label: 'Venta rápida' },
      ].map((option) => (
        <button
          key={option.id}
          type="button"
          aria-pressed={createMode === option.id}
          onClick={() => switchMode(option.id)}
          className={`rounded-lg px-3 py-2 text-sm font-semibold transition-colors ${
            createMode === option.id ? 'bg-[#1F80FF] text-white' : tabInactive
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  ) : null;

  if (isQuickNew) {
    return (
      <div className={`flex w-full flex-col rounded-xl border overflow-hidden ${box}`}>
        <div className={`shrink-0 border-b p-0.5 ${divide}`}>
          {modeToggleInner}
        </div>
        <VentaRapidaForm
          embedded
          formResetKey={quickFormResetKey}
          onAdd={onAdd}
          modoOscuro={modoOscuro}
          existingInvoices={facturas}
          preferImpagaOnboarding={preferImpagaOnboarding}
          onRequestCompleteMode={() => switchMode('complete')}
        />
      </div>
    );
  }

  return (
    <div className="w-full space-y-2">
      <PlanUsageBanner modoOscuro={modoOscuro} variant="compact" className="w-full" />
      <FormShell
        box={box}
        divide={divide}
        textPri={textPri}
        textMuted={textMuted}
        title={title}
        subtitle={subtitle}
        headerClassName="px-4 py-2.5"
        bodyClassName="p-4"
        titleClassName="text-sm"
        iconWrapClassName="w-8 h-8"
        icon={
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
        }
      >
        {modeToggleInner && (
          <div className={`mb-4 rounded-xl border p-1 ${box}`}>
            {modeToggleInner}
          </div>
        )}

        <FacturaForm
          onAdd={editId !== null ? onSaveEdit : onAdd}
          initialData={editData}
          editMode={editId !== null}
          onCancel={onCancelEdit}
          modoOscuro={modoOscuro}
          existingInvoices={facturas}
        />
      </FormShell>
    </div>
  );
}
